import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';

export const OptionsWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  min-height: 24px;
  padding: 2px;
  border-radius: 4px;
  background-color: ${theme.colors.secondary300};
`;

const activeOptionStyles = css`
  background-color: ${theme.colors.mainBlue};
  color: #fff;
`;

const inactiveOptionStyles = css`
  &:not(:disabled):hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

export const Option = styled.button<{ $active: boolean }>`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  color: ${theme.colors.secondary900};
  ${({ $active }) => ($active ? activeOptionStyles : inactiveOptionStyles)}
`;

export const Label = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
`;
